var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.662 14.0465C15.8766 14.2611 15.9971 14.5521 15.9971 14.8556C15.9971 15.1591 15.8766 15.4502 15.662 15.6648C15.4474 15.8794 15.1563 16 14.8528 16C14.5493 16 14.2582 15.8794 14.0436 15.6648L7.99952 9.61883L1.95353 15.6629C1.73892 15.8775 1.44785 15.9981 1.14435 15.9981C0.840851 15.9981 0.54978 15.8775 0.335173 15.6629C0.120565 15.4483 3.1979e-09 15.1572 0 14.8537C-3.1979e-09 14.5502 0.120565 14.2592 0.335173 14.0446L6.38117 8.00048L0.337077 1.95448C0.122469 1.73987 0.00190399 1.4488 0.00190399 1.1453C0.001904 0.841803 0.122469 0.550732 0.337077 0.336125C0.551684 0.121517 0.842754 0.000951818 1.14626 0.000951815C1.44976 0.000951812 1.74083 0.121517 1.95543 0.336125L7.99952 6.38212L14.0455 0.335173C14.2601 0.120565 14.5512 -5.05633e-09 14.8547 0C15.1582 5.05633e-09 15.4493 0.120565 15.6639 0.335173C15.8785 0.54978 15.999 0.84085 15.999 1.14435C15.999 1.44785 15.8785 1.73892 15.6639 1.95353L9.61788 8.00048L15.662 14.0465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconWhite);
export default __webpack_public_path__ + "static/media/x_icon_white.aece2cdebe2eaf66caceb26d0237c6c9.svg";
export { ForwardRef as ReactComponent };